import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Grid, Paper, Typography } from "@mui/material";

import dayjs from "dayjs";

import actions from "../../../../store/actions";
import ls from "../../../../Localization";
import { State } from "store/reducers";
import { MeiDetailState } from "store/reducers/mei/detail";
import useStyles from "./styles";

import Invoices from "./Invoices";
import Invoicing from "./Invoicing";

import { useNavigate, useParams } from "react-router-dom";
import { CNPJ, CPF } from "Components/NumberFormat";
import { MeiLogisticOperatorStatus } from "Types/IMei";
import { isInRole } from "helpers/auth";

export function MeiDetail() {
	const navigate = useNavigate();
	const { id } = useParams();
	const classes = useStyles({});
	const dispatch = useDispatch<any>();

	useEffect(() => {
		if (!id) return;

		dispatch(actions.mei.detail.clearValues());
		dispatch(actions.mei.detail.getMei(id));
	}, [dispatch, id]);

	const { item } = useSelector<State, MeiDetailState>(s => s.meiDetail);
	const { user } = useSelector<State, any>(s => s.login);

	const handleEdit = () => {
		navigate(`/Dashboard/Mei/${item._id}/Edit`);
	};

	if (!item) return null;

	const {
		createdAt,
		personName,
		businessName,
		cpf,
		cnpj,
		situation,
		startDate,
		openingDate,
		occupation,
		emissionDate,
		activity,
		ccmei,
		type,
		logisticOperator,
		logisticOperatorStatus,
		parentOperator
	}: any = item;

	return (
		<Grid container justifyContent="center" spacing={5}>
			<Grid item xs={11}>
				<Paper className={classes.root}>
					<div className={classes.header}>
						<Typography variant="h6">{ls.meiData}</Typography>
						<div>
							{isInRole(user, ["admin"]) && (
								<Button color="primary" onClick={handleEdit}>
									{ls.edit}
								</Button>
							)}
						</div>
					</div>
					<hr className={classes.line} />

					<Grid container spacing={2} className={classes.form}>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.creationDate}</strong>:{" "}
							{dayjs(createdAt).format(ls.dateFormatWithoutSeconds)}
						</Grid>

						<Grid item xs={12} sm={6} md={6} lg={4}>
							<strong>{ls.name}</strong>: {personName}
						</Grid>

						<Grid item xs={12} sm={6} md={6} lg={5}>
							<strong>{ls.businessName}</strong>: {businessName}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.cpf}</strong>: <CPF value={cpf} displayType="text" />
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.cnpj}</strong>:{" "}
							<CNPJ value={cnpj} displayType="text" />
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.situation}</strong>: {situation || "-"}
						</Grid>

						<Grid item xs={12}>
							<strong>{ls.activity}</strong>: {activity || "-"}
						</Grid>

						<Grid item xs={12}>
							<strong>{ls.occupation}</strong>: {occupation || "-"}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.openingDate}</strong>:{" "}
							{openingDate
								? dayjs(Number(openingDate)).format(ls.dateFormatShort)
								: "-"}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.startDate}</strong>:{" "}
							{startDate
								? dayjs(Number(startDate)).format(ls.dateFormatShort)
								: "-"}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>{ls.emissionDate}</strong>: {emissionDate || "-"}
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<strong>CCMEI</strong>:{" "}
							<a href={ccmei} target="_blank">
								Abrir em nova guia
							</a>
						</Grid>
						{Number(type) === 0 && (
							<>
								<Grid item xs={12} sm={12} md={6} lg={6}>
									<strong>{ls.logisticOperator}</strong>:{" "}
									{logisticOperator
										? `${logisticOperator.businessName} - ${logisticOperator.cnpj}`
										: "Nenhum"}
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<strong>{ls.logisticOperatorStatus}</strong>:{" "}
									{ls[MeiLogisticOperatorStatus[logisticOperatorStatus || 0]]}
								</Grid>
							</>
						)}
						{Number(type) === 1 && parentOperator && (
							<Grid item xs={12} sm={12} md={6} lg={6}>
								<strong>{ls.parentOperator}</strong>:{" "}
								{parentOperator.businessName || parentOperator.socialName || parentOperator.cnpj}
							</Grid>
						)}
					</Grid>
				</Paper>
			</Grid>

			<Grid item xs={11}>
				<Invoicing id={id} />
			</Grid>
			<Grid item xs={11}>
				<Invoices id={id} />
			</Grid>
		</Grid>
	);
}

export default MeiDetail;
